import { CurrentUser } from '@/core/user/models/CurrentUser';
import { CmsCredentialToCreateDTO } from '@/core/admin/DTO/CmsCredentialsDTO';
import { container } from 'tsyringe';
import { AdminService } from '@/core/admin/services/AdminServices';
import { CmsCredentialData } from '@/core/admin/models/CmsCredential';
import { Customer } from '@/core/customer/models/Customer';
import { UpdateCmsCredentialsDTO } from '@/core/admin/DTO/UpdateCmsCredentialsDTO';

export const createCmsCredentialUseCase = async (
  currentUser: CurrentUser,
  cmsCredentialToCreate: CmsCredentialToCreateDTO,
): Promise<void> => {
  const adminService = container.resolve<AdminService>('AdminService');

  return await adminService.createCmsCredential(currentUser, cmsCredentialToCreate);
};

export const deleteCmsCredentialUseCase = async (currentUser: CurrentUser, customerId: string) => {
  const adminService = container.resolve<AdminService>('AdminService');
  await adminService.deleteCmsCredential(currentUser, customerId);
};

export const getAllCmsCredentialsUseCase = async (user: CurrentUser): Promise<CmsCredentialData[]> => {
  const adminService = container.resolve<AdminService>('AdminService');

  return await adminService.getAllCmsCredentialEntries(user);
};

export const getAllCustomersWithoutCmsCredentialUseCase = async (user: CurrentUser): Promise<Customer[]> => {
  const adminService = container.resolve<AdminService>('AdminService');

  return await adminService.getAllCustomersWithoutCmsCredential(user);
};

export const updateCmsCredentialsUseCase = async (
  currentUser: CurrentUser,
  cmsCredentialToUpdate: UpdateCmsCredentialsDTO,
): Promise<void> => {
  const adminService = container.resolve<AdminService>('AdminService');
  await adminService.updateCmsCredential(currentUser, cmsCredentialToUpdate);
};
